import { Link } from 'react-router-dom';
import { GenericCatalogTable } from "../../../components/generic-catalog-table";
import { ScrollReveal } from "../../../components/scroll-reveal";
import { CERTIN_CONTROLS } from "../../../data/certin-controls";

export default function CertInFramework() {
  const columns = [
    { accessorKey: "controlId", header: "Control ID", size: 110 },
    { accessorKey: "category", header: "Category", size: 160 },
    { accessorKey: "controlRequirement", header: "Control Requirement", size: 320 },
    { accessorKey: "reportingTimeline", header: "Reporting Timeline", size: 140 },
    { accessorKey: "logTypesCovered", header: "Log Types Covered", size: 240 },
    { accessorKey: "retentionRequirement", header: "Retention", size: 140 },
    { accessorKey: "evidenceRequired", header: "Evidence Required", size: 240 },
    { accessorKey: "responsibleFunction", header: "Responsible Function", size: 170 },
    { accessorKey: "verificationMethod", header: "Verification Method", size: 180 },
    { accessorKey: "automationApproach", header: "Automation Approach", size: 180 },
    { accessorKey: "severity", header: "Severity", size: 120 },
  ];
  return (
    <div>
      <section
        className="relative overflow-hidden py-16"
        style={{ background: "var(--gradient-hero)" }}
      >
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            Indian Regulatory Frameworks / CERT-In
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            CERT-In Directions on
            <br />
            Cyber Security Practices
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Mandatory incident reporting and log retention requirements for government,
            regulated entities, and service providers.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#certin-catalog"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download Incident Catalog
            </a>
            <a
              href="#portal-guide"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View Reporting Portal Guide
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to RBI →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Incident Types", v: "21" },
              { k: "Reporting Window", v: "6 Hours" },
              { k: "Log Retention", v: "180 Days" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  {s.k}
                </div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="certin-catalog">
        <div className="container-ivalue">
          <ScrollReveal>
            <div>
              <h2 className="text-3xl font-extrabold tracking-[-0.02em] text-text-primary md:text-5xl">
                CERT-In control catalog
              </h2>
              <p className="mt-3 max-w-3xl text-lg text-text-secondary">
                Search, filter, export and operationalize mandatory CERT-In reporting and retention controls.
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-10">
            <GenericCatalogTable
              data={CERTIN_CONTROLS}
              columns={columns}
              csvColumns={[
                { header: "Control ID", accessorKey: "controlId" },
                { header: "Category", accessorKey: "category" },
                { header: "Control Requirement", accessorKey: "controlRequirement" },
                { header: "Timeline", accessorKey: "reportingTimeline" },
                { header: "Log Types", accessorKey: "logTypesCovered" },
                { header: "Retention", accessorKey: "retentionRequirement" },
                { header: "Evidence", accessorKey: "evidenceRequired" },
                { header: "Owner", accessorKey: "responsibleFunction" },
                { header: "Verification", accessorKey: "verificationMethod" },
                { header: "Automation", accessorKey: "automationApproach" },
                { header: "Severity", accessorKey: "severity" },
              ]}
            />
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="portal-guide">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="grid gap-6 lg:grid-cols-2">
              <div className="glass-card p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  Incident classification flowchart
                </div>
                <div className="mt-3 text-lg font-semibold text-text-primary">
                  Decision tree (placeholder)
                </div>
                <div className="mt-3 text-sm leading-relaxed text-text-secondary">
                  In Part 4, we can add an interactive flowchart to help teams determine incident category and enforce the 6-hour SLA.
                </div>
              </div>

              <div className="glass-card p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  Reporting portal integration guide
                </div>
                <div className="mt-3 text-lg font-semibold text-text-primary">
                  Step-by-step guide (placeholder)
                </div>
                <div className="mt-3 text-sm leading-relaxed text-text-secondary">
                  We'll add portal instructions, evidence packaging, and SOAR-assisted submission flow.
                </div>
              </div>

              <div className="glass-card p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  180-day log architecture diagram
                </div>
                <div className="mt-3 text-lg font-semibold text-text-primary">
                  Reference architecture (placeholder)
                </div>
                <div className="mt-3 text-sm leading-relaxed text-text-secondary">
                  Storage tiering, WORM retention, India residency and retrieval drill design.
                </div>
              </div>

              <div className="glass-card p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  NTP requirements
                </div>
                <div className="mt-3 text-lg font-semibold text-text-primary">
                  NIC/NPL sync guidance (placeholder)
                </div>
                <div className="mt-3 text-sm leading-relaxed text-text-secondary">
                  We'll add configuration snippets and compliance checks for fleet-wide time drift monitoring.
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
